import React, { Component } from 'react';
import { Alert, FormGroup, FormControl, FormLabel, Button, HelpBlock } from 'react-bootstrap';
import StatusMessage from "../lib/statusmessage"
import { getMyLicenses, createKey } from '../api/developer-keys';
class CreateAppLicenseApp extends Component {
  constructor(props) {
    super(props);
    this.prefixes = ['XA', 'XU', 'XI', 'XE', 'SU', 'SE', 'AJ', 'S9','AH'];
    this.baseProductSkus = ["54083", "58272", "58316" , "58202", "58304", "58306", "58546"];
    this.state = {
      my_licenses: [],
      initing:true,
      serial: this.props.LicenseID || null,
      selected_license: null,
      app_type:null,
      app_name:null,
      key:null,
      user_id: this.props.UserID,
      error: false,
      loading:false,
      validation:{
        formLicenseSelect:null,
        formAppTypeSelect: null,
        formAppNameTxt: null
      }
    };
    this.getMyLicenses = this.getMyLicenses.bind(this);
    this.handleSerialSelect = this.handleSerialSelect.bind(this);
    this.submit = this.submit.bind(this);
    this.generateLicense = this.generateLicense.bind(this);
    this.handleSerialSelectChange = this.handleSerialSelectChange.bind(this);
  }

  async componentWillMount() {
    try {
      let _my_licenses = await this.getMyLicenses();
      _my_licenses = _my_licenses.sort((a,b)=>{
        return a.PurchaseDate > b.PurchaseDate ? -1:1
      })
      this.setState({
        my_licenses: _my_licenses,
        initing:false
      },()=>{
        this.handleSerialSelectChange();
      });
    } catch (ex) {
      console.log(ex);
      this.setState({
        initing:false
      })
    }
  }

  async getMyLicenses() {
    try{
      let licenses = await getMyLicenses(this.state.user_id);
      return licenses;
    }catch(ex){
      console.log(ex);
      this.setState({
        error: new StatusMessage({
          Status: 'danger',
          Message: 'Could not fetch licenses.',
        })
      })
    }

  }

  async generateLicense(data){
    this.setState({loading:true});
    try{
      const key = await createKey(data);
      this.setState({loading:false});
      return key;
    }
    catch(ex){
      this.setState({loading:false});
      throw new Error(ex);
    } 
  }

  handleSerialSelect(e){
    this.setState({
      serial: e.currentTarget.value,
      selected_license : this.state.my_licenses.filter((item)=>{ 
        return item.Key == e.currentTarget.value
      })[0]
    });
    
  }

  componentDidUpdate(oldProps, oldState){
    if( oldState.serial !== this.state.serial){
      this.handleSerialSelectChange();
    } 
  }

  handleSerialSelectChange(){
    let {opt_xamarin,opt_uwp, opt_aspcore, opt_default, opt_dotnet, opt_dotnetcore, opt_dotnetstandard} = this.refs;
    
    //Disable all options first, then enable again based on key
    opt_xamarin.disabled = opt_uwp.disabled =  opt_aspcore.disabled = opt_dotnet.disabled = opt_dotnetcore.disabled = opt_dotnetstandard.disabled =true;
    opt_default.selected = true;

    //Interpret the serial key and what they can generate for
    if(this.state.serial !== null){
      let prefix = this.state.serial.slice(0,2);
      this.setState({app_type:null});
  
      switch(prefix.toLowerCase()){
        case 'xa': //Xuni specific keys
        case 'xe':
        case 'xi':
        case 'xu':
          opt_xamarin.disabled = false;
          break;
        case 's9'://ASPCore specific key
          opt_aspcore.disabled = false;
          break;
        case 'aj':
          opt_uwp.disabled =  false;
          break;
        case 'se': //Studio Enterprise
          opt_uwp.disabled =  opt_aspcore.disabled = false;
          if(Number(this.state.serial.slice(3,5)) >= 19){
            opt_xamarin.disabled = false;
          }
          break;
        case 'su': //Studio Ultimate
        case "ev": //Evaluation 30-day trial code, enable all
          opt_xamarin.disabled = opt_uwp.disabled =  opt_aspcore.disabled = opt_dotnet.disabled = opt_dotnetcore.disabled = opt_dotnetstandard.disabled =false;
          break;
        default:
          switch(this.state.selected_license.ProductSku.BaseProductSkuid){
            case "54083": //SE
              opt_xamarin.disabled = opt_uwp.disabled =  opt_aspcore.disabled = opt_dotnet.disabled = opt_dotnetcore.disabled = opt_dotnetstandard.disabled =false;
              break;
            case "58272":
              opt_aspcore.disabled = false;
              break;
            case "58316":
              opt_uwp.disabled =  false;
              break;
            case "58202":
            case "58304":
            case "58306":
            case "58546":
              opt_xamarin.disabled = false;
              break;
            default: 
              break;
          }
      }
    }
    
  }
  
  async submit(){
    //validation
    let {serial, app_type, app_name} = this.state;
    let _formLicenseSelect = serial === "default" ||serial === null ? "error":null;
    let _formAppTypeSelect = app_type === "default" || app_type=== null?  "error":null;
    let _formAppNameTxt = app_name ==="" || app_name === null ? "error":null;
    this.setState({
      validation:{
        formLicenseSelect: _formLicenseSelect,
        formAppTypeSelect: _formAppTypeSelect,
        formAppNameTxt: _formAppNameTxt
      }
    });

    if(_formLicenseSelect ==null && _formAppTypeSelect==null &&  _formAppNameTxt==null){
      try{
        let _key = await this.generateLicense({
          serial:serial,
          app_type: app_type,
          app_name: app_name,
          UserID:this.state.user_id,
        });
        this.setState({
          key:_key.Value
        });
        return;
      }
      catch(ex){
        this.setState({
          key:ex.message
        });
        return;
      }

    }

  }

  render() {
    if(!this.state.initing){
      return (
        <div>
        {this.state.error && 
          <Alert variant={'danger'}>
            {this.state.error.Message}
          </Alert>
        }
        <h2>Generate an App Key</h2>
        <form>
          <FormGroup controlId="formLicenseSelect" validationState={this.state.validation.formLicenseSelect}>
            <FormLabel>Select License</FormLabel>
            <FormControl ref="license_dropdown" componentClass="select" as="select" placeholder="select" onChange={this.handleSerialSelect} >
              <option value="default" key="default">Choose one...</option>
              <option value="eval" key="eval">Evaluation License</option>
              {this.state.my_licenses.map((item, index) => {


                if(this.prefixes.indexOf(item.Key.slice(0,2)) >-1){
                  return <option  key={item.Key}  value={item.Key} selected={this.state.serial === item.Key? "selected":""}>{item.Key} - {item.ProductSku.ProductName}</option>;
                }else{
                  
                  if(!(this.prefixes.indexOf(item.Key.slice(0,2)) >-1)&& item.ProductSku && this.baseProductSkus.indexOf(item.ProductSku.BaseProductSkuid) >-1){
                    return <option  key={item.Key} value={item.Key} selected={this.state.serial === item.Key? "selected":""}>{item.Key} - {item.ProductSku.ProductName} (For Legacy Apps)</option>;
                  }
                  
                }
              }, this)}
            </FormControl>
            <FormControl.Feedback />
            {
              this.state.validation.formLicenseSelect ==="error" &&
              <Alert variant={'danger'}>Please select a License</Alert>
            }
          </FormGroup>
          <FormGroup controlId='formAppTypeSelect' validationState={this.state.validation.formAppTypeSelect} >
              <FormLabel>App Type</FormLabel>
              <FormControl componentClass="select" placeholder="select" as="select" onChange={(e)=>{this.setState({app_type:e.target.value})}}>
                <option ref="opt_default" value="default">Choose one...</option>
                <option ref="opt_xamarin" disabled={true} value="xamarin">Xamarin</option>
                <option ref="opt_uwp" disabled={true} value="uwp">UWP</option>
                <option ref="opt_aspcore" disabled={true} value="aspcore">ASP.NET Core</option>
                <option ref="opt_dotnet" disabled={true} value="dotnet">.NET</option>
                <option ref="opt_dotnetcore" disabled={true} value="dotnetcore">.NET Core</option>
                <option ref="opt_dotnetstandard" disabled={true} value="dotnetstandard">.NET Standard</option>
              </FormControl>
              <FormControl.Feedback />
              {
                this.state.validation.formAppTypeSelect ==="error" &&
                <Alert variant={'danger'}>Please select an App Type</Alert>
              }

          </FormGroup>
          <FormGroup controlId='formAppNameTxt' validationState={this.state.validation.formAppNameTxt}>
            <FormLabel>App Name</FormLabel>
              <FormControl
              type="text"
              placeholder="Enter App Name"
              onChange={(e)=>{
                this.setState({app_name:e.target.value})
              }}
              onKeyPress={(e)=>{
                if(e.charCode ===13){
                  e.preventDefault();
                  this.submit();
                }
                
              }}
              ></FormControl>
              <FormControl.Feedback />
              {
                this.state.validation.formAppNameTxt ==="error" &&
                <Alert variant={'danger'}>Please enter your application name</Alert>
              }
          </FormGroup>
          <Button onClick={this.submit} type="button" className={"form-control gc-btn primary-action"}>Generate App Key
          {this.state.loading && 
            <i className="fa-spinner fa fa-spin" />
          }
          </Button>


          { this.state.key &&
            <div>
              <h3>Copy this key and use it in your apps immediately.</h3>
              <p><a href="/licensing/generate-app-key">Get more information on how to use your app key.</a></p>
              <textarea rows="15" className="app-key-gen" readOnly value={this.state.key}>
              </textarea>
            </div>
          }
        </form>
        </div>
        
      );
    }else{
      return(
        <div>
        <h2>Loading...</h2>
        </div>
      );

    }
  }
}

export default CreateAppLicenseApp;
